import React from 'react'
import { LegalMarkdown } from '@/components/legal-markdown'
import { englishTermsV1 } from './content/english-terms-v1'
import { englishTermsV2 } from './content/english-terms-v2'

interface EnglishUserTermsAndConditionsProps {
    version: number
}

export const EnglishUserTermsAndConditions: React.FC<EnglishUserTermsAndConditionsProps> = ({
    version,
}) => {
    const content = version === 2 || version === 0 ? englishTermsV2 : englishTermsV1

    return <LegalMarkdown content={content} />
}
